import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { AuthenticationService } from '../../../services/authentication.service';
import { CommonService } from '../../../services/common.service';
import { ProfileService } from '../../../services/profile.service';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';

export interface CertificateData {
    id: string;
    btnDisabled: boolean;
    btnDownloadText: string;
    trainingName: string;
    completedOn: string;
}

@Component({
  selector: 'app-profile-certificates',
  templateUrl: './profile-certificates.component.html',
  styleUrls: ['./profile-certificates.component.scss']
})
export class ProfileCertificatesComponent implements AfterViewInit {

    displayedColumns: string[] = ['certificate'];
    dataSource: MatTableDataSource<CertificateData>;

    @ViewChild(MatPaginator)
    paginator!: MatPaginator;
    @ViewChild(MatSort)
    sort!: MatSort;

    pagecode: string = "profile-certificates";
    module: string = "profile";
    accessdenied: boolean = false;

    constructor(private sanitizer: DomSanitizer, private route: ActivatedRoute,
        private _router: Router, private profileService: ProfileService,
        private authentication: AuthenticationService,
        private common: CommonService) {

        this.dataSource = new MatTableDataSource(this.myCertificates);

        this.route.params.subscribe(val => {
            this.authentication.checkUserPageAccess(this.authentication._authentication.id, this.pagecode).subscribe(
                (res: any) => {
                    if (res.success && res.data) {

                        var pageURL = this._router.routerState.snapshot.url;
                        this.authentication.addUserPageView(pageURL, this.pagecode, this.module);

                        // load page data
                        this.getMyCertificates();

                        //

                    }
                    else {
                        this.accessdenied = true;
                    }
                },
                (err: any) => {
                    console.error("checkUserPageAccess", err);
                    this.accessdenied = true;
                }
            );
        });

    }

    clickedRows(row: any) {
        this.downloadCertificate(row);
    }

    ngAfterViewInit(): void {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }
    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }
    loadingMessage: string = "Loading...";

    myCertificates: Array<CertificateData> = [];

    downloadCertificate(item: any) {
        item.btnDisabled = true;
        item.btnDownloadText = "Downloading";
        this.profileService.downloadCertificate(item.id, this.authentication._authentication.id).subscribe(
            (res: any) => {

                //let data: any = this.rootScope.base64ToArrayBuffer(res.certificate);

                //let blob = new Blob([data]);
                let link = document.createElement('a');
                link.href = res.certificateURL;
                let fileName = "certificate_" + item.id + ".pdf";
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                item.btnDisabled = false;
                item.btnDownloadText = "Download";

            },
            (err: any) => {
                item.btnDisabled = false;
                item.btnDownloadText = "Download";
                console.error("downloadCertificate error", err);
            }
        );
    }
    getMyCertificates() {

        this.profileService.getMyCertificates(this.authentication._authentication.id).subscribe(
            (res: any) => {
                //this.myCertificates = [];

                for (var i = 0; i < res.length; i++) {
                    res[i].btnDisabled = false;
                    res[i].btnDownloadText = "Download";
                    this.myCertificates.push({
                        id: res[i].id,
                        btnDisabled: false,
                        btnDownloadText: "Download",
                        trainingName: res[i].training.trainingName,
                        completedOn: res[i].completedOn
                    });
                }
                if (this.myCertificates.length == 0)
                    this.common.ShowMessage('info', 'No Certificates Found', '');
                //console.log("myCertificates", this.myCertificates);
                this.dataSource = new MatTableDataSource(this.myCertificates);
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
                this.loadingMessage = "No data found";
            },
            (err: any) => {
                //this.loadingMsg = err;
                //this.myCertificates = [];
                console.error("getMyCertificates error", err);
            }
        );
    }
}
